import { render, staticRenderFns } from "./ResultEntryWords.vue?vue&type=template&id=11b7aca9&"
import script from "./ResultEntryWords.vue?vue&type=script&lang=js&"
export * from "./ResultEntryWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports